import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useCookies } from 'react-cookie';

export const useLoginByPassword = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [_, setCookie] = useCookies(['token']);

  const [loading, setLoading] = useState(false);

  const loginByPassword = (phoneNumber, password) => {
    setLoading(true);

    axiosClient
      .post(`/Account/Login?PhoneNumber=${phoneNumber}&Password=${password}`)
      .then(res => {
        if (res.data.value.token !== null) {
          setCookie('token', res.data.value.token, {
            path: '/',
            expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
          });
        } else {
          enqueueSnackbar(res.data?.message, { variant: 'error' });
        }
      })
      .catch(() => {
        enqueueSnackbar('خطای شبکه', { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };

  return [loading, loginByPassword];
};
